import Vendor from '@/service/vendor'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {
    vendorInfo: JSON.parse(localStorage.getItem('zs.vendorInfo')) || {}
  },
  mutations: {
    setVendorForStorage() {}
  },
  actions: {
    getapplyvendors(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getapplyvendors(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getvendors(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getvendors(payload), {
        type: 'list',
        success,
        fail
      })
    },
    applyvendor(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.applyvendor(payload), {
        type: 'action',
        success,
        fail
      })
    },
    auditvendor(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.auditvendor(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatevendor(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.updatevendor(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getapplyvendor(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getapplyvendor(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getvendor(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getvendor(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getvendorForStorage({ commit }, { payload = {}}) {
      RequestUtils.fetchWrapper(Vendor.getvendor(payload), {
        type: 'info',
        success(res) {
          commit('setVendorForStorage', res.data)
          localStorage.setItem('zs.vendorInfo', JSON.stringify(res.data))
        },
        fail() {}
      })
    },
    getvendorcodingtypes(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getvendorcodingtypes(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getvendortagtypes(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getvendortagtypes(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getvendortradetypes(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getvendortradetypes(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getvendorregulators(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getvendorregulators(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getvendorcategorys(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getvendorcategorys(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getappinfo(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getappinfo(payload), {
        type: 'info',
        success,
        fail
      })
    },
    resetappkey(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.resetappkey(payload), {
        type: 'action',
        success,
        fail
      })
    },
    setappinfo(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.setappinfo(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getexpresses(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getexpresses(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getallexpresses(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getallexpresses(payload), {
        type: 'list',
        success,
        fail
      })
    },
    setvendorexpress(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.setvendorexpress(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getcustomers(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getcustomers(payload), {
        type: 'list',
        success,
        fail
      })
    },
    updatecustomer(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.updatecustomer(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getdepartments(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getdepartments(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getdepartmentstaffs(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getdepartmentstaffs(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getdeliverytrace(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vendor.getdeliverytrace(payload), {
        type: 'info',
        success,
        fail
      })
    }
  }
}
